// pipe (frontend wave FB): Inbound Orders sidebar entry. Cloned from records-button.tsx (verbatim
// shape). Not admin-gated: the server enforces every read/write authority and the screen renders
// the localized load-error state.
import { useI18n } from '@affine/i18n';
import { ImportIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const InboundButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  const active = useNavPrefixActive(workbench, '/inbound');

  return (
    <MenuLinkItem icon={<ImportIcon />} active={active} to={'/inbound'}>
      <span data-testid="pipe-inbound-nav">
        {t['com.affine.pipe.inbound.nav']()}
      </span>
    </MenuLinkItem>
  );
};
